import { render, staticRenderFns } from "./eb-nav-link.vue?vue&type=template&id=66221344&"
import script from "./eb-nav-link.vue?vue&type=script&lang=js&"
export * from "./eb-nav-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports